<script lang="ts">
	import { Snapshot } from "luxedo-data"

	interface Props {
		snapshot: Snapshot
		selected: boolean
		onselect: () => void
	}

	let { snapshot, selected, onselect }: Props = $props()
</script>

<div
	class="snapshot-instance"
	class:selected
	onclick={onselect}
	onkeydown={(e) => (e.key === "Enter" ? onselect() : null)}
	tabindex="0"
	role="button"
>
	<div class="image-container transparent-bg">
		<img
			src={snapshot.src}
			alt="Snapshot captured on {snapshot.datesaved.toLocaleString()}"
			crossorigin="anonymous"
		/>
	</div>
</div>

<style>
	.snapshot-instance {
		width: fit-content;
		height: fit-content;

		border-radius: var(--br);
		overflow: hidden;
		box-sizing: border-box;
		outline: 1px solid var(--color-border);
		cursor: pointer;

		transition: outline 250ms;
	}

	.selected {
		outline: 3px solid var(--color-main);
	}

	.image-container {
		width: 100%;
		position: relative;
		aspect-ratio: 16 / 9;
		overflow: hidden;
	}

	.image-container img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}
</style>
